module.exports = __webpack_public_path__ + "static/media/ionicons.05acfdb5.woff";